import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './FieldAndAppAttendanceComapring.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getDistrict, getProject, getStates, fetchMonths, getMonthlyAttendanceReport, getClients, getAppAndFieldAttendanceCompare, getAppAndFieldAttendanceCompareDrilldown, getEmployeeSummaryDrilldown, getEmployeeSummaryDrilldownFullDetails } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../utils/validations';
import { getDesignationsForEmployees } from '../../../services/shiftsService';
const FieldAndAppAttendanceComapring = () => {
    const currentYear = new Date().getFullYear();
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(currentYear);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);
    const [clientResponse, setClientResponse] = useState([]);
    const [clients, setClients] = useState(1);
    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        month: false,
        year: false,
        project: false,
        clients: false,
        designation: false
    });
    const [errors, setErrors] = useState({});
    const yearInputRef = useRef(null);
    const [designationData, setDesignationData] = useState([]);

    const [designationOptions, setDesignationOptions] = useState([]);
    const [designation, setDesignation] = useState("");
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const isFetchDataEnabled = state && month && year;

    // Add these with your other useState declarations
    const [drillDownData, setDrillDownData] = useState([]);
    const [selectedDesignation, setSelectedDesignation] = useState(null);
    const [isDrillDown, setIsDrillDown] = useState(false);
    const [drillDownLoading, setDrillDownLoading] = useState(false);

    // ===== LEVEL 2 DRILL-DOWN (Employee Level) =====
    const [employeeData, setEmployeeData] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [viewLevel, setViewLevel] = useState(1); // 1 = main, 2 = district, 3 = employee
    const [employeeLoading, setEmployeeLoading] = useState(false);


    // ===== LEVEL 3 DRILL-DOWN (Employee Level) =====
    const [employeeDataFullDetails, setEmployeeDataFullDetails] = useState([]);
    const [employeeFullDetails, setEmployeeFullDetails] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [employeeDetailsLoading, setEmployeeDetailsLoading] = useState(false);

    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);




    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonths(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);


    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    //const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${state}`);
                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            // if (!effectRan.current) {
            fetchDistricts();
            // }
            // return () => {
            //     effectRan.current = true;
            // }

        } else {
            setDistrictOptions([]);
            setDistrict(null);
        }
    }, [state]);
    useEffect(() => {
        if (state) {
            const fetchClients = async () => {
                try {
                    const data = await getClients(state);
                    setClientResponse(
                        data.map(client => ({
                            value: client.id,
                            label: client.clientName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching clients:', error);
                    setErrors(prev => ({ ...prev, clients: 'Failed to load clients' }));
                }
            };
            fetchClients();
        } else {
            setClientResponse([]);
            setClients(null);



        }
    }, [state]);
    useEffect(() => {
        if (clients) {
            const fetchProjects = async () => {
                try {
                    const data = await getProject(clients);
                    setProjectResponse(data.map(pro => ({
                        value: pro.id,
                        label: pro.projectCode,
                    })));
                } catch (error) {
                    console.error('Error fetching projects:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
                }
            };

            fetchProjects();
        } else {
            setProjectResponse([]); // Reset projects if no client is selected
        }
    }, [clients]);

    const loadDesignations = async () => {
        try {
            const data = await getDesignationsForEmployees();
            const list = data.map(d => ({
                value: d.designationShortName,
                label: d.designationName,
            }));
            setDesignationOptions(list);
        } catch (error) {
            console.error("Error loading designations:", error);
        }
    };
    useEffect(() => {
        loadDesignations();
    }, []);

    // Clear attendance data and fetch status when any dropdown changes
    useEffect(() => {
        setAttendanceData([]);
        // setOriginalData([]);
        setHasFetched(false);
    }, [state, district, month, year, project]); // ✅ Add project to depende

    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setClients(null);
                setProject(null); // ✅ Clear project when state changes

                break;
            case 'district':
                setDistrict(value);
                // setProject(null); // ✅ Clear project when district changes
                break;

            case 'month':
                setMonth(value);
                break;
            case "designation":
                setDesignation(value);
                break;

            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const handleYearChange = (date) => {
        setYear(date ? date.getFullYear() : null);
        setErrors(prev => ({ ...prev, year: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        if (!month) newErrors.month = 'Month is required';
        if (!year) newErrors.year = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const data = await getAppAndFieldAttendanceCompare(state, district, year, month, designation)

            const employeeData = data.summary || [];

            setAttendanceData(employeeData);

        } catch (error) {
            console.error("Error fetching report data:", error);
            setErrors((prev) => ({
                ...prev,
                general: "Failed to fetch report data",
            }));
            alert("Failed to fetch report data. Please try again.");
        }
    };
    // ===== LEVEL 1: Click on designation → show district-wise =====
    const handleDesignationClick = async (designation) => {
        if (!designation) return;

        try {
            setDrillDownLoading(true);
            setSelectedDesignation(designation);
            setViewLevel(2);
            setDrillDownData([]);

            const data = await getAppAndFieldAttendanceCompareDrilldown(
                state, district, year, month, designation
            );

            setDrillDownData(data.summary || data || []);
        } catch (error) {
            console.error("Error fetching drill-down data:", error);
            setErrors(prev => ({ ...prev, general: "Failed to fetch drill-down data" }));
        } finally {
            setDrillDownLoading(false);
        }
    };

    // ===== LEVEL 2: Click on district → show employee-wise =====
    const handleDistrictClick = async (districtRow) => {
        if (!districtRow?.districtId) return;

        try {
            setEmployeeLoading(true);
            setSelectedDistrict(districtRow);
            setViewLevel(3);
            setEmployeeData([]);

            const data = await getEmployeeSummaryDrilldown(
                districtRow.districtId,
                year,
                month,
                selectedDesignation
            );

            setEmployeeData(Array.isArray(data) ? data : (data.summary || []));
        } catch (error) {
            console.error("Error fetching employee data:", error);
            setErrors(prev => ({ ...prev, general: "Failed to fetch employee data" }));
        } finally {
            setEmployeeLoading(false);
        }
    };

    /// =============== Leve 3: Employee FullDetails =================
    // ===== LEVEL 3: Click on employee → show full details =====
    const handleEmployeeClick = async (employeeRow) => {
        if (!employeeRow?.employeeUniqueId) {
            console.warn("No employeeUniqueId found on row:", employeeRow);
            return;
        }

        try {
            setEmployeeDetailsLoading(true);
            setSelectedEmployee(employeeRow);
            setViewLevel(4);
            setEmployeeFullDetails(null);

            const data = await getEmployeeSummaryDrilldownFullDetails(
                year,
                month,
                employeeRow.employeeUniqueId
            );

            setEmployeeFullDetails(data || null);
        } catch (error) {
            console.error("Error fetching employee full details:", error);
            setErrors(prev => ({ ...prev, general: "Failed to fetch employee details" }));
        } finally {
            setEmployeeDetailsLoading(false);
        }
    };

    // ===== Back button logic (multi-level) =====
    const handleBackToMain = () => {
        // Level 4 → back to Level 3
        if (viewLevel === 4) {
            setViewLevel(3);
            setEmployeeFullDetails(null);
            setSelectedEmployee(null);
            return;
        }
        // Level 3 → back to Level 2
        if (viewLevel === 3) {
            setViewLevel(2);
            setEmployeeData([]);
            setSelectedDistrict(null);
            return;
        }
        // Level 2 → back to Level 1
        if (viewLevel === 2) {
            setViewLevel(1);
            setDrillDownData([]);
            setSelectedDesignation(null);
            return;
        }
        setViewLevel(1);
    };

    // Reset everything when filters change
    useEffect(() => {
        setViewLevel(1);
        setDrillDownData([]);
        setEmployeeData([]);
        setEmployeeFullDetails(null);
        setSelectedEmployee(null);
        setSelectedDesignation(null);
        setSelectedDistrict(null);
    }, [state, district, month, year]);


    // const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);



    return (
        <div className="appfield-report-container">
            <div className="appfield-report-box">
                <h2 className="appfield-report-heading">Field And App Attendance Comparison</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleSubmit}
                >
                    <div className="appfield-report-maincontainer">
                        <div className="appfield-report-container-part">
                            <div className={`appfield-report-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="appfield-report-container-part">
                            <div className={`appfield-report-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label> District</label>
                                {/* {errors.district && <div className="error-message">{errors.district}</div>} */}
                            </div>
                        </div>
                    </div>

                    <div className="appfield-report-maincontainer">
                        <div className="appfield-report-container-part">
                            <div className={`appfield-report-floating-label-container ${isFocused.designation || designation ? 'float-label' : ''}`}>
                                <Select
                                    name="designation"
                                    options={designationOptions}
                                    value={designationOptions.find(opt => opt.value === designation) || null}
                                    onChange={option => handleInputChange(option, "designation")}
                                    // placeholder="Select Designation"
                                    isClearable
                                    className="w-100"
                                />
                                <label>Designation</label>
                                {/* {errors.designation && <div className="error-message">{errors.designation}</div>} */}
                            </div>
                        </div>
                        <div className="appfield-report-container-part">
                            <div className={`appfield-report-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={year ? new Date(year, 0, 1) : null}
                                    onChange={handleYearChange}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    placeholderText=""
                                    className="appfield-report-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}

                                    title="Select a year"
                                />
                                <label><span className="required">*</span>Year</label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>

                    </div>

                    <div className="appfield-report-maincontainer">
                        <div className="appfield-report-container-part">
                            <div className={`appfield-report-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                <Select
                                    name="month"
                                    options={monthOptions}
                                    value={monthOptions.find(opt => opt.value === month) || null}
                                    onChange={option => handleInputChange(option, 'month')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Month</label>
                                {errors.month && <div className="error-message">{errors.month}</div>}
                            </div>
                        </div>
                        <div className="appfield-report-container-part">

                        </div>

                    </div>

                    <div className="appfield-report-btn-div">
                        <button type="submit" className="appfield-report-btn"
                            disabled={!isFetchDataEnabled}


                        >
                            Generate Report
                        </button>
                    </div>
                </form>
            </div>


            <div className="report-table-monthlt-att-container">

                {/* ===================== LEVEL 1: MAIN SUMMARY ===================== */}
                {viewLevel === 1 && (
                    <table className="report-table-monthlt-att">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Designation</th>
                                <th>Field Attendance Count</th>
                                <th>App Attendance Count</th>
                                <th>Difference</th>
                            </tr>
                        </thead>
                        <tbody>
                            {attendanceData.length > 0 ? (
                                attendanceData.map((row, idx) => {
                                    const vacancy = Math.abs((row.fieldCount || 0) - (row.appAttendanceCount || 0));
                                    return (
                                        <tr
                                            key={idx}
                                            onClick={() => handleDesignationClick(row.designation)}
                                            className="clickable-row"
                                            style={{ cursor: "pointer" }}
                                            title={`View district-wise details for ${row.designation}`}
                                        >
                                            <td>{idx + 1}</td>
                                            <td>{row.designation}</td>
                                            <td>{row.fieldCount}</td>
                                            <td>{row.appAttendanceCount}</td>
                                            <td>{vacancy}</td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                                        No attendance data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        {attendanceData.length > 0 && (
                            <tfoot>
                                <tr className="report-total-row bg-warning-subtle">
                                    <td colSpan="2" className="report-total-label">Total</td>
                                    <td>{attendanceData.reduce((s, r) => s + (r.fieldCount || 0), 0)}</td>
                                    <td>{attendanceData.reduce((s, r) => s + (r.appAttendanceCount || 0), 0)}</td>
                                    {/* Level 1 */}
                                    <td>
                                        {attendanceData.reduce(
                                            (s, r) => s + Math.abs((r.fieldCount || 0) - (r.appAttendanceCount || 0)),
                                            0
                                        )}
                                    </td>
                                </tr>
                            </tfoot>
                        )}
                    </table>
                )}

                {/* ===================== LEVEL 2: DISTRICT DRILL-DOWN ===================== */}
                {viewLevel === 2 && (
                    <>
                        <div className="drilldown-header">
                            <h3 className="drilldown-title">
                                District-wise Details for: <strong>{selectedDesignation}</strong>
                            </h3>
                            <button type="button" className="back-btn" onClick={handleBackToMain}>
                                ← Back to Summary
                            </button>
                        </div>

                        <table className="report-table-monthlt-att">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>District Name</th>
                                    <th>Field Attendance Count</th>
                                    <th>App Attendance Count</th>
                                    <th>Difference</th>
                                </tr>
                            </thead>
                            <tbody>
                                {drillDownLoading ? (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                                            Loading...
                                        </td>
                                    </tr>
                                ) : drillDownData.length > 0 ? (
                                    drillDownData.map((row, idx) => {
                                        const difference = Math.abs((row.fieldCount || 0) - (row.appAttendanceCount || 0));
                                        return (
                                            <tr
                                                key={row.districtId || idx}
                                                onClick={() => handleDistrictClick(row)}
                                                className="clickable-row"
                                                style={{ cursor: "pointer" }}
                                                title={`View employees in ${row.districtName}`}
                                            >
                                                <td>{idx + 1}</td>
                                                <td>{row.districtName}</td>
                                                <td>{row.fieldCount}</td>
                                                <td>{row.appAttendanceCount}</td>
                                                <td>{difference}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                                            No district data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                            {drillDownData.length > 0 && (
                                <tfoot>
                                    <tr className="report-total-row bg-warning-subtle">
                                        <td colSpan="2" className="report-total-label">Total</td>
                                        <td>{drillDownData.reduce((s, r) => s + (r.fieldCount || 0), 0)}</td>
                                        <td>{drillDownData.reduce((s, r) => s + (r.appAttendanceCount || 0), 0)}</td>
                                        {/* Level 2 */}
                                        <td>
                                            {drillDownData.reduce(
                                                (s, r) => s + Math.abs((r.fieldCount || 0) - (r.appAttendanceCount || 0)),
                                                0
                                            )}
                                        </td>
                                    </tr>
                                </tfoot>
                            )}
                        </table>
                    </>
                )}

                {/* ===================== LEVEL 3: EMPLOYEE DRILL-DOWN ===================== */}
                {viewLevel === 3 && (
                    <>
                        <div className="drilldown-header">
                            <h3 className="drilldown-title">
                                Employees in <strong>{selectedDistrict?.districtName}</strong> —{" "}
                                <strong>{selectedDesignation}</strong>
                            </h3>
                            <button type="button" className="back-btn" onClick={handleBackToMain}>
                                ← Back to District List
                            </button>
                        </div>

                        <table className="report-table-monthlt-att">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Employee ID</th>
                                    <th>Employee Name</th>
                                    <th>Designation</th>
                                    <th>Field Attendance Count</th>
                                    <th>App Attendance Count</th>
                                    <th>Difference</th>
                                </tr>
                            </thead>
                            <tbody>
                                {employeeLoading ? (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                                            Loading...
                                        </td>
                                    </tr>
                                ) : employeeData.length > 0 ? (
                                    employeeData.map((row, idx) => {
                                        const difference = Math.abs((row.fieldCount || 0) - (row.appAttendanceCount || 0));
                                        return (
                                            // ✅ CORRECT — pass function reference
                                            <tr
                                                key={row.employeeId || idx}
                                                onClick={() => handleEmployeeClick(row)}
                                                className="clickable-row"
                                                style={{ cursor: "pointer" }}
                                                title={`View details for ${row.employeeName}`}
                                            >
                                                <td>{idx + 1}</td>
                                                <td>{row.employeeId}</td>
                                                <td>{row.employeeName}</td>
                                                <td>{row.designation}</td>
                                                <td>{row.fieldCount}</td>
                                                <td>{row.appAttendanceCount}</td>
                                                <td>{difference}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                                            No employee data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                            {employeeData.length > 0 && (
                                <tfoot>
                                    <tr className="report-total-row bg-warning-subtle">
                                        <td colSpan="4" className="report-total-label">Total</td>
                                        <td>{employeeData.reduce((s, r) => s + (r.fieldCount || 0), 0)}</td>
                                        <td>{employeeData.reduce((s, r) => s + (r.appAttendanceCount || 0), 0)}</td>
                                        {/* Level 3 */}
                                        <td>
                                            {employeeData.reduce(
                                                (s, r) => s + Math.abs((r.fieldCount || 0) - (r.appAttendanceCount || 0)),
                                                0
                                            )}
                                        </td>
                                    </tr>
                                </tfoot>
                            )}
                        </table>
                    </>
                )}


                {/* ===================== LEVEL 4: EMPLOYEE FULL DETAILS ===================== */}
                {viewLevel === 4 && (
                    <>
                        <div className="drilldown-header">
                            <h3 className="drilldown-title">
                                Employee Details:{" "}
                                <strong>{selectedEmployee?.employeeName}</strong>
                                {" "}
                                <span style={{ fontSize: "13px", color: "#666" }}>
                                    ({selectedEmployee?.employeeId})
                                </span>
                            </h3>
                            <button type="button" className="back-btn" onClick={handleBackToMain}>
                                ← Back to Employee List
                            </button>
                        </div>

                        {employeeDetailsLoading ? (
                            <div style={{ textAlign: "center", padding: "40px" }}>Loading...</div>
                        ) : employeeFullDetails ? (
                            <div className="employee-details-wrapper">

                                {/* -------- Employee Info Card -------- */}
                                <div className="employee-info-card">
                                    <div className="info-row">
                                        <span className="info-label">Employee Name:</span>
                                        <span className="info-value">{employeeFullDetails.employeeName}</span>
                                    </div>
                                    <div className="info-row">
                                        <span className="info-label">Designation:</span>
                                        <span className="info-value">{employeeFullDetails.designation}</span>
                                    </div>
                                    <div className="info-row">
                                        <span className="info-label">Mobile Number:</span>
                                        <span className="info-value">{employeeFullDetails.mobileNumber}</span>
                                    </div>
                                    <div className="info-row">
                                        <span className="info-label">Month / Year:</span>
                                        <span className="info-value">
                                            {monthOptions.find(o => o.value === employeeFullDetails.month)?.label || employeeFullDetails.month}
                                            {" / "}
                                            {employeeFullDetails.year}
                                        </span>
                                    </div>
                                </div>

                                {/* -------- Attendance Comparison Table -------- */}
                                <table className="report-table-monthlt-att employee-details-tables">
                                    <thead>
                                        <tr>
                                            <th colSpan="2" className="section-head field-head">
                                                Field Count Summary
                                            </th>
                                            <th colSpan="2" className="section-head app-head">
                                                App Count Summary
                                            </th>
                                        </tr>
                                        <tr className="sub-header-row">
                                            <th>Category</th>
                                            <th>Count</th>
                                            <th>Category</th>
                                            <th>Count</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* Field rows (left) + App rows (right) — rendered row-by-row */}
                                        <tr>
                                            <td>Present Days</td>
                                            <td>{employeeFullDetails.fieldPresentDays ?? 0}</td>
                                            <td>Present Days</td>
                                            <td>{employeeFullDetails.appPresentCount ?? 0}</td>
                                        </tr>
                                        <tr>
                                            <td>Absent Days</td>
                                            <td>{employeeFullDetails.fieldAbsentDays ?? 0}</td>
                                            <td>Absent Days</td>
                                            <td>{employeeFullDetails.appAbsentCount ?? 0}</td>
                                        </tr>
                                        <tr>
                                            <td>Casual Leaves</td>
                                            <td>{employeeFullDetails.fieldCasualLeaves ?? 0}</td>
                                            <td>Casual Leave</td>
                                            <td>{employeeFullDetails.appLeaveCount ?? 0}</td>
                                        </tr>
                                        <tr>
                                            <td>—</td>
                                            <td>—</td>
                                            <td>LOP (Loss of Pay)</td>
                                            <td>{employeeFullDetails.appLopCount ?? 0}</td>
                                        </tr>
                                        <tr>
                                            <td>—</td>
                                            <td>—</td>
                                            <td>Week Off</td>
                                            <td>{employeeFullDetails.appWeekOffCount ?? 0}</td>
                                        </tr>
                                        <tr>
                                            <td>—</td>
                                            <td>—</td>
                                            <td>Holiday</td>
                                            <td>{employeeFullDetails.appHolidayCount ?? 0}</td>
                                        </tr>
                                    </tbody>

                                    {/* ================= TOTAL ROW ================= */}
                                    <tfoot>
                                        <tr className="report-total-row bg-warning-subtle">
                                            <td className="report-total-label">Total Present Days</td>
                                            <td>
                                                {(employeeFullDetails.fieldPresentDays || 0) +
                                                    // (employeeFullDetails.fieldAbsentDays || 0) +
                                                    (employeeFullDetails.fieldCasualLeaves || 0)}
                                            </td>
                                            <td className="report-total-label">Total Present Days</td>
                                            <td>
                                                {(employeeFullDetails.appPresentCount || 0) +
                                                    (employeeFullDetails.appAbsentCount || 0) +
                                                    (employeeFullDetails.appLeaveCount || 0) +
                                                    // (employeeFullDetails.appLopCount || 0) +
                                                    (employeeFullDetails.appWeekOffCount || 0) +
                                                    (employeeFullDetails.appHolidayCount || 0)}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        ) : (
                            <div style={{ textAlign: "center", padding: "40px" }}>
                                No details found for this employee.
                            </div>
                        )}
                    </>
                )}

            </div>

        </div>
    );
};

export default FieldAndAppAttendanceComapring;